@if (visible()) {
    <div class="plate">
        <ev-logo-loader minWidth="80px" width="10vw" shadowColor="#607A8D" label="Henter kartdata" />
    </div>
}
